import { Pagination } from "api/models/response/pagination";
import {
  createConditionalNaturalLanguageString,
  formatNumber,
} from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { packingNoteBusiness } from "api/bussiness/package-note/packing-note-business";
import { GetPackingNotes } from "api/models/request/packing-note/packing-note";
import { withReset } from "mobx-stores/_extension/with-reset";
import {
  IPackingNoteProperties,
  PackingNote,
} from "mobx-stores/_models/packing-note/packing-note";
import { PackingNoteItem } from "mobx-stores/_models/packing-note/packing-note-item";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";

export const PackingPrintManagement = types
  .model({
    open: false,
    variant: types.optional(
      types.union(types.literal("10"), types.literal("6")),
      "10"
    ),
    selectedPackingNoteItem: types.maybeNull(PackingNoteItem),
  })
  .actions(withSetPropAction)
  .actions(withReset);

export const PackingNoteQueryParams = types
  .model({
    poDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    deliveryDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    name: "",
    dealingName: "",
    number: "",
    code: "",
    barcode: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get natureLanguageString() {
      const map = new Map<
        string,
        { label: string; value: string | number | null | undefined }
      >([
        ["number", { label: "số phiếu", value: self.number }],
        ["dealingName", { label: "tên giao dịch", value: self.dealingName }],
        ["name", { label: "tên hàng", value: self.name }],
        ["code", { label: "mã hàng", value: self.code }],
        ["barcode", { label: "mã barcode", value: self.barcode }],
      ]);

      return createConditionalNaturalLanguageString(map);
    },
  }));
export const PackingNoteManagement = types
  .model({
    packingNotes: types.optional(types.array(PackingNote), []),
    pagination: types.optional(PaginationStore, {}),
    packingNoteDetail: types.maybeNull(PackingNote),
    openNew: false,
    openEdit: false,
    openDelete: false,
    packingPrintingManagement: types.optional(PackingPrintManagement, {}),
    queryParams: types.optional(PackingNoteQueryParams, {}),
    searchConditionAsNaturalLanguage: "",
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.natureLanguageString;
      return `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      }Tổng cộng: ${formatNumber(self.pagination.totalItems)} phiếu`;
    },
  }))
  .actions((self) => ({
    getPackingNotes: flow(function* getPackingNotes(request?: GetPackingNotes) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            number: self.queryParams.number,
            code: self.queryParams.code,
            barcode: self.queryParams.barcode,
          };
        }
        const res = (yield packingNoteBusiness.getLists(
          request
        )) as Pagination<IPackingNoteProperties>;
        self.setProp(
          "packingNotes",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          }))
        );
        self.pagination.setProp("totalItems", res.totalCount);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getPackingNoteDetail: flow(function* getPackingNoteDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield packingNoteBusiness.getById(
          id
        )) as IPackingNoteProperties;
        self.setProp("packingNoteDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
